import axios from 'axios';

const publicApiKey = process.env.REACT_APP_PUBLIC_API_KEY;

export const validateCryptoAccount = async (email) => {
    return axios.get(
        `/api/public/crypto-account/validate/${email}`,
        {headers: { Authorization: `Bearer ${publicApiKey}`}}
    );
};
